import React,{useState,useEffect} from "react";
import china_pic from "../../assets/china.webp";
import azerb_pic from "../../assets/azerbaijan.webp";
import logoWhite from "../../assets/logo white.svg";
import logoBlue from "../../assets/logo blue.svg";
import "./Home.scss";
import { IoIosArrowRoundUp } from "react-icons/io";
import {Link} from "react-router-dom";

function Home() {
  const [hover, setHover] = useState(1);
  // const [matches, setMatches] = useState(
  //   window.matchMedia("(max-width: 780px)").matches
  // )
  
  // useEffect(() => {
  //   window
  //   .matchMedia("(max-width: 780px)")
  //   .addEventListener('change', e => setMatches( e.matches ));
  // }, []);

  return (
    <div className="container">
      <div className="frame"></div>

      <img
        src={hover === 1 ? logoWhite :logoBlue}
        alt="logo"
        className={
          hover === 0 ? "logo left" : hover === 2 ? "logo right" : "logo"
        }
      />
      <div className="half china">
        
        <Link to="/china" className="link">
        
          <div className={hover === 0 ? "pulse-blue" : "pulse"}></div>

          <IoIosArrowRoundUp
            color={hover === 0 ? "#1f5da2" : ""}
            className="arrIcon _cn"
            onMouseEnter={() => setHover(0)}
            onMouseLeave={() => setHover(1)}
          />
        </Link>
       
        
        <h1  className={hover === 0 ? "title_cn title_cn_hover" : "title_cn"}>КИТАЙ</h1>

        <img
          src={china_pic}
          loading="lazy"
          alt="china"
          className={hover === 0 ? "white-img" : ""}
        />
      </div>
      <div className="half azerbaijan">
      <Link to="/azerbaijan" className="link">
        
        <div className={hover === 2 ? "pulse-blue" : "pulse"}></div>

        <IoIosArrowRoundUp
          color={hover === 2 ? "#1f5da2" : ""}
          className="arrIcon _aze"
          onMouseEnter={() => setHover(2)}
          onMouseLeave={() => setHover(1)}
        />
      </Link>
        <h1 className={hover === 2 ? "title_aze title_aze_hover" : "title_aze"}>阿塞拜疆</h1>

        <img
          src={azerb_pic}
          loading="lazy"
          alt="azerbaijan"
          className={hover === 2 ? "white-img" : ""}
        />
      </div>
    </div>
  );
}

export default Home;
